var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgPinnedMessageIcon = function SvgPinnedMessageIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M12 14h5.816a1 1 0 0 0 .877-1.479l-1.385-2.54a10 10 0 0 1-1.085-3.145l-.584-3.5a1 1 0 0 0-.986-.836H8.92a1 1 0 0 0-.996.917l-.249 2.979a10 10 0 0 1-1.186 3.958L5.307 12.52A1 1 0 0 0 6.185 14zm0 0v7.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPinnedMessageIcon);
export { ForwardRef as Icon };
export default "customIcons/pinned-message-icon.fb9a58b.svg";